module.exports = __webpack_public_path__ + "img/AshleyWakefield.25e049f4.jpg";